"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LinearProgress = _interopRequireDefault(require("@mui/material/LinearProgress"));
var _uiTheme = require("@kyruus/ui-theme");
const _overrides = theme => ({
  MuiLinearProgress: {
    styleOverrides: {
      bar: {
        background: theme.color_button
      }
    }
  }
});
const ProgressComponent = (0, _uiTheme.withMuiThemeAdapter)(_LinearProgress.default, _overrides);
// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.
const Progress = props => /*#__PURE__*/_react.default.createElement(ProgressComponent, props);
Progress.displayName = 'LinearProgress';
// PropTypes taken from material-ui.
Progress.propTypes = {
  /**
   * The variant of show your progress, indeterminate
   * for when there is no value for progress.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query']),
  /**
   * The value of progress, only works in determinate and buffer variant.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,
  /**
   * The value of buffer, only works in buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes.default.number
};
Progress.defaultProps = {
  variant: 'indeterminate'
};
var _default = exports.default = Progress;
Progress.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LinearProgress",
  "props": {
    "variant": {
      "defaultValue": {
        "value": "'indeterminate'",
        "computed": false
      },
      "description": "The variant of show your progress, indeterminate\nfor when there is no value for progress.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'determinate'",
          "computed": false
        }, {
          "value": "'indeterminate'",
          "computed": false
        }, {
          "value": "'buffer'",
          "computed": false
        }, {
          "value": "'query'",
          "computed": false
        }]
      },
      "required": false
    },
    "value": {
      "description": "The value of progress, only works in determinate and buffer variant.\nValue between 0 and 100.",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "valueBuffer": {
      "description": "The value of buffer, only works in buffer variant.\nValue between 0 and 100.",
      "type": {
        "name": "number"
      },
      "required": false
    }
  }
};